import Service, { inject as service } from '@ember/service';

// This service was built so we can wrap the ember intl package and prefix
// the translation keys with a specific country.
// The main issue is we need to be able to control what version of English
// translators see and atm, we need to nest everything under the specific country key

export default Service.extend({
  capitalEngineContext: service(),
  intl: service(),
  t(key, params) {
    let translationKey;
    const newParams = Object.assign({}, params);

    // Japan has custom English so we want to use the jp prefixed version of keys for those strings
    // Japanese translations will all be prefixed with jp
    if (this.capitalEngineContext.localeContext.countryCode === 'JP') {
      translationKey = `jp.${key}`;
      // line breaks will be part of Japanese translations so we want to honor these in the html
      newParams.htmlSafe = true;
      if (!this.intl.t(translationKey, newParams).string.startsWith('Missing translation')) {
        return this.intl.t(translationKey, newParams);
      }
    }
    return this.intl.t(key, params);
  }
});